import React, { createContext, useState, useContext, useCallback } from "react";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Create the Snackbar context
const SnackBarContext = createContext();

// Custom hook to access the Snackbar context
export const useSnackBar = () => {
  return useContext(SnackBarContext);
};

// SnackBarProvider component to wrap your application with
export function SnackBarProvider({ children }) {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    message: "",
    typ: "",
  });

  const [snackbarDuration, setSnackbarDuration] = useState(1000);

  // Function to show the Snackbar
  const showSnackbar = useCallback((type, message, duration = 1000) => {
    setSnackbarMessage({ message, typ: type });
    setSnackbarDuration(duration);
    setSnackbarOpen(true);
  }, []);

  // Function to hide the Snackbar
  const hideSnackbar = useCallback(() => {
    setSnackbarOpen(false);
  }, []);

  return (
    <SnackBarContext.Provider
      value={{ snackbarOpen, snackbarMessage, showSnackbar, hideSnackbar }}
    >
      {children}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={snackbarDuration}
        onClose={hideSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={hideSnackbar}
          severity={snackbarMessage.typ}
          sx={{ background: snackbarMessage.typ }}
        >
          {snackbarMessage.message}
        </Alert>
      </Snackbar>
    </SnackBarContext.Provider>
  );
}
